import {
  Box,
  Grid,
  makeStyles,
  TextField,
  InputAdornment,
  Button,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { Skeleton } from "@material-ui/lab";
import { editDelivery, editPrice } from "../../../redux-store/books/actions";
import { useDispatch } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    borderTop: `1px solid ${theme.palette.secondary.dark}`,
    margin: "20px 0",
  },
  sectionHeading: {
    fontSize: 20,
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  priceFields: {
    padding: 8,
    margin: "5px 0",
    width: "80%",
  },
  formControlLabel: {
    color: "red",
  },
  subHeading: {
    fontSize: 16,
    fontWeight: 550,
    margin: "10px 0 1px 0",
  },
  subValue: {
    fontSize: 16,
    fontWeight: 500,
    margin: "0px 0 5px 0",
  },
  button: {
    justifyContent: "end",
  },
}));

function BookTypes(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { bookId, pricing, currentBook } = props;
  const [hardCover, setHardCover] = useState(true);
  const [standard, setStandard] = useState(true);
  const [eBook, setEBook] = useState(true);
  const [disable, setDisable] = useState(false);
  const [hardPrice, setHardPrice] = useState(0);
  const [standardPrice, setStandardPrice] = useState(0);
  const [ePrice, setEPrice] = useState(0);
  const [editMode, setEditMode] = useState(false);
  useEffect(() => {
    fetchCurrentBook();
  }, []);
  const fetchCurrentBook = () => {
    setHardPrice(parseInt(currentBook.price?.hardcover_price));
    setStandardPrice(parseInt(currentBook.price?.paperback_price));
    setEPrice(parseInt(currentBook.price?.digital_price));
  };
  const handleUpdatePrice = () => {
    let updatedPrice = {};
    if (hardCover) {
      updatedPrice = { ...updatedPrice, hardcover_price: hardPrice };
    }
    if (standard) {
      updatedPrice = { ...updatedPrice, paperback_price: standardPrice };
    }
    if (eBook) {
      updatedPrice = { ...updatedPrice, digital_price: ePrice };
    }
    dispatch(editPrice({ price: updatedPrice }, bookId));

    setEditMode(false);
  };
  return (
    <div className={classes.root}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <h2 className={classes.sectionHeading}>Book Types</h2>
        {editMode ? (
          <div className={classes.button}>
            <Button
              variant="outlined"
              onClick={handleUpdatePrice}
              disabled={ ePrice <= 0}
            >
              Update
            </Button>
            <Button
              style={{ marginLeft: "3px" }}
              variant="outlined"
              color="secondary"
              onClick={() => setEditMode(false)}
            >
              Cancel
            </Button>
          </div>
        ) : (
          <Button
            variant="outlined"
            disabled={currentBook.print_on_demand == "admin"}
            onClick={() => setEditMode(true)}
          >
            Edit
          </Button>
        )}
      </Box>
      {currentBook ? (
        <Box mt={1}>
          {editMode ? (
            <Grid container spacing={2}>
          
           
              <Grid item xs={12} sm={6} md={4} xl={3}>
                {eBook && (
                  <TextField
                    label="Digital Ebook Price"
                    type="number"
                    value={ePrice}
                    onChange={(e) => setEPrice(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                      inputProps: { min: 0 },
                    }}
                    variant="outlined"
                    className={classes.priceFields}
                    disabled={disable}
                  />
                )}
              </Grid>
            </Grid>
          ) : (
            <Box>
              {currentBook && currentBook.price && (
                <Grid container spacing={2}>
            
               
                  {currentBook.price.digital_price !== undefined &&
                    currentBook.price.digital_price !== 0 && (
                      <Grid item xs={12} sm={6} md={4} xl={3}>
                        <h3 className={classes.subHeading}>Digital E Book</h3>
                        <h3 className={classes.subValue}>
                          $ {currentBook.price.digital_price}
                        </h3>
                   
                      </Grid>
                      
                    )}
                    
                </Grid>
              )}
            </Box>
          )}
        </Box>
      ) : (
        <Box>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton animation="wave" width={250} height={50} />
              <Skeleton animation="wave" width={150} height={30} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton animation="wave" width={250} height={50} />
              <Skeleton animation="wave" width={150} height={30} />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Skeleton animation="wave" width={250} height={50} />
              <Skeleton animation="wave" width={150} height={30} />
            </Grid>
          </Grid>
        </Box>
      )}
    </div>
  );
}

export default BookTypes;
